const errorsConfig = require('./errors-config');

module.exports = errorsConfig;
